"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const prop_types_1 = __importDefault(require("prop-types"));
const totangoTheme_1 = require("../../theme/totangoTheme");
const Tooltip = ({ text, title, placement, showArrow, children, enterDelay, disable, leaveDelay, removeTooltip, ...restProps }) => (removeTooltip || !(title || text) ? (children) : (react_1.default.createElement(styles_1.MuiThemeProvider, { theme: totangoTheme_1.totangoTheme },
    react_1.default.createElement(Tooltip_1.default, { placement: placement, enterDelay: enterDelay, leaveDelay: leaveDelay, title: title || text || '', disableFocusListener: disable, disableHoverListener: disable, disableTouchListener: disable, arrow: showArrow, ...restProps }, children))));
exports.default = Tooltip;
Tooltip.defaultProps = {
    enterDelay: undefined,
    leaveDelay: undefined,
    disable: false,
    placement: 'top',
    text: undefined,
    title: undefined,
    showArrow: true,
    removeTooltip: false,
};
Tooltip.propTypes = {
    enterDelay: prop_types_1.default.number,
    leaveDelay: prop_types_1.default.number,
    disable: prop_types_1.default.bool,
    showArrow: prop_types_1.default.bool,
    text: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.string]),
    title: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.string, prop_types_1.default.number]),
    placement: prop_types_1.default.oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top',
    ]),
    children: prop_types_1.default.element.isRequired,
    removeTooltip: prop_types_1.default.bool,
};
//# sourceMappingURL=tooltip.js.map